import { fetchUserKeys as fetchUserKeysHttpRequest } from '../api';
import { createUserKey as createUserKeyHttpRequest } from '../api';
import { updateUserKey as updateUserKeyHttpRequest } from '../api';

export const REQUEST_USER_KEYS = 'REQUEST_USER_KEYS';
export const RECEIVE_USER_KEYS = 'RECEIVE_USER_KEYS';
export const RECEIVE_USER_KEYS_ERROR = 'RECEIVE_USER_KEYS_ERROR';
export const REQUEST_SAVE_USER_KEY = 'REQUEST_SAVE_USER_KEY';
export const RECEIVE_SAVE_USER_KEY = 'RECEIVE_SAVE_USER_KEY';
export const RECEIVE_SAVE_USER_KEY_ERROR = 'RECEIVE_SAVE_USER_KEY_ERROR';

/**
 * Request user keys Redux action creator
 */
export function requestUserKeys() {
    return {
        type: REQUEST_USER_KEYS,
    };
}

/**
 * Receive user keys Redux action creator
 * @param {array} userKeys
 */
export function receiveUserKeys(userKeys) {
    return {
        type: RECEIVE_USER_KEYS,
        userKeys,
        receivedAt: Date.now(),
    };
}

/**
 * Receive user keys error Redux action creator
 * @param {Error} error
 */
export function receiveUserKeysError(error) {
    return {
        type: RECEIVE_USER_KEYS_ERROR,
        error,
    };
}

/**
 * Request save user key Redux action creator
 */
export function requestSaveUserKey() {
    return {
        type: REQUEST_SAVE_USER_KEY,
    };
}

/**
 * Receive save user key Redux action creator
 * @param {object} key
 */
export function receiveSaveUserKey(key) {
    return {
        type: RECEIVE_SAVE_USER_KEY,
        key,
        receivedAt: Date.now(),
    };
}

/**
 * Receive save user key error Redux action creator
 * @param {Error} error
 */
export function receiveSaveUserKeyError(error) {
    return {
        type: RECEIVE_SAVE_USER_KEY_ERROR,
        error,
    };
}

export function fetchUserKeys() {
    return (dispatch, getState) => {
        dispatch(requestUserKeys());
        const user = getState().user;
        return fetchUserKeysHttpRequest(user.group.Id)
            .then(userKeys => dispatch(receiveUserKeys(userKeys)))
            .catch(error => dispatch(receiveUserKeysError(error)));
    };
}

export function saveUserKey(data, userKeyId) {
    return (dispatch, getState) => {
        dispatch(requestSaveUserKey());
        const user = getState().user;
        const request = userKeyId ? updateUserKeyHttpRequest : createUserKeyHttpRequest;

        return request(user.group.Id, data, userKeyId)
            .then(() => dispatch(receiveSaveUserKey(data)))
            .catch(error => dispatch(receiveSaveUserKeyError(error)));
    };
}
